import { addNavMenuItem } from "@vendure/admin-ui/core";

export default [
  addNavMenuItem(
    {
      id: "tax-overview",
      label: "Steuer-Übersicht",
      routerLink: ["/extensions/steuern/uebersicht"],
      icon: "calculator",
      requiresPermission: "ReadCatalog"
    },
    "catalog"
  )
];
